import { Theme, css } from '@emotion/react';

export const autocompleteStyles = ({ palette }: Theme) => css`
  input {
    padding-top: 3.5px !important;
    padding-bottom: 3.5px !important;
  }
  & .MuiAutocomplete-option[data-focus='true'] {
    background: ${palette.action.hover};
  }
`;

export const autocompleteInputStyles = css`
  & .MuiInputLabel-root {
    transform: translate(14px, 12.5px) scale(1);
  }
`;
